module.exports = __webpack_public_path__ + "static/media/novemLogo.f2771e5b.svg";